var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFewCloudsDayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.356,
    height: 24,
    viewBox: "0 0 24.356 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "few-clouds-day-icon",
    transform: "translate(-43 -69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(71.5 127)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 16,
    height: 16,
    transform: "translate(-21.5 -57.5)",
    fill: "rgba(252,252,252,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Path",
    cx: 3.333,
    cy: 3.333,
    r: 3.333,
    transform: "translate(-16.558 -52.833)",
    fill: "none",
    stroke: "#ffb100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line",
    y2: 1.333,
    transform: "translate(-13.5 -56.833)",
    fill: "none",
    stroke: "#ffb100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-2",
    y2: 1.333,
    transform: "translate(-13.5 -43.5)",
    fill: "none",
    stroke: "#ffb100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-3",
    x2: 0.947,
    y2: 0.947,
    transform: "translate(-18.412 -54.687)",
    fill: "none",
    stroke: "#ffb100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-4",
    x2: 0.947,
    y2: 0.947,
    transform: "translate(-8.985 -45.26)",
    fill: "none",
    stroke: "#ffb100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-5",
    x2: 1.333,
    transform: "translate(-20.833 -49.5)",
    fill: "none",
    stroke: "#ffb100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-6",
    x2: 1.333,
    transform: "translate(-7.5 -49.5)",
    fill: "none",
    stroke: "#ffb100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-7",
    y1: 0.947,
    x2: 0.947,
    transform: "translate(-18.412 -45.26)",
    fill: "none",
    stroke: "#ffb100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-8",
    y1: 0.947,
    x2: 0.947,
    transform: "translate(-8.985 -54.687)",
    fill: "none",
    stroke: "#ffb100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(72 127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area-2",
    "data-name": "Area",
    width: 24,
    height: 24,
    transform: "translate(-29 -58)",
    fill: "rgba(252,252,252,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2-2",
    "data-name": "Icon-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M-9.868-45H-11.96c-1.463-5.665-8.641-8.339-13.768-3.442a5.626,5.626,0,0,0-1.415,2.174C-29.305-40.174-24.986-35-19.7-35h9c3.919,0,6.785-4.507,3.695-8.62A3.571,3.571,0,0,0-9.868-45Z",
    fill: "#fff",
    stroke: "#364456",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewCloudsDayIcon);
export default __webpack_public_path__ + "static/media/few-clouds-day-icon.755c8590e7bda8ca501ed38a0b516815.svg";
export { ForwardRef as ReactComponent };